import { render, staticRenderFns } from "./frozenFilBalanceDetail.vue?vue&type=template&id=005b39ce&scoped=true&"
import script from "./frozenFilBalanceDetail.vue?vue&type=script&lang=js&"
export * from "./frozenFilBalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./frozenFilBalanceDetail.vue?vue&type=style&index=0&id=005b39ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b39ce",
  null
  
)

export default component.exports